// Common SVG Arrow Icon Components
// Use: import { ArrowLeftIcon, ArrowRightIcon } from '../../helpers/common/ArrowIcons';
import React from 'react';

export function ArrowLeftIcon(props) {
  return (
    <svg viewBox="0 0 18 18" role="img" aria-label="Previous" focusable="false" style={{ height: '22px', width: '22px', display: 'block', fill: '#fff', ...props.style }}>
      <path d="m13.7 16.29a1 1 0 1 1 -1.42 1.41l-8-8a1 1 0 0 1 0-1.41l8-8a1 1 0 1 1 1.42 1.41l-7.29 7.29z"></path>
    </svg>
  );
}

export function ArrowRightIcon(props) {
  return (
    <svg viewBox="0 0 18 18" role="img" aria-label="Next" focusable="false" style={{ height: '22px', width: '22px', display: 'block', fill: '#fff', ...props.style }}>
      <path d="m4.29 1.71a1 1 0 1 1 1.42-1.41l8 8a1 1 0 0 1 0 1.41l-8 8a1 1 0 1 1 -1.42-1.41l7.29-7.29z"></path>
    </svg>
  );
}
